"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.opportunitySchema = void 0;
const zod_1 = require("zod");
exports.opportunitySchema = {
    general: zod_1.z.object({
        description: zod_1.z
            .object({
            context: zod_1.z.string().describe('Contexte'),
            tasks: zod_1.z.array(zod_1.z.string()).describe('Missions'),
            place: zod_1.z.string().describe('Phrase de localisation'),
            homeOffice: zod_1.z.string().describe('Télétravail'),
        })
            .describe('Description'),
        criteria: zod_1.z
            .object({
            experience: zod_1.z.string().describe('Expérience'),
            authorizations: zod_1.z.array(zod_1.z.string()).describe('Habilitations'),
            certifications: zod_1.z.array(zod_1.z.string()).describe('Certifications'),
            hardSkills: zod_1.z.array(zod_1.z.string()).describe('Compétences'),
            languages: zod_1.z
                .array(zod_1.z.object({
                language: zod_1.z.string().describe('Langue'),
                level: zod_1.z.string().describe('Niveau'),
            }))
                .describe('Languages'),
            softSkills: zod_1.z.string().describe('Savoir être'),
        })
            .describe('Critères'),
    }),
    asideFields: {
        tools: zod_1.z.object({
            tools: zod_1.z.array(zod_1.z.string()).describe('Outils'),
        }),
        activityAreas: zod_1.z.object({
            activityAreas: zod_1.z.array(zod_1.z.string()).describe('Domaines'),
        }),
        expertiseArea: zod_1.z.object({
            expertiseArea: zod_1.z.string().describe('Secteur'),
        }),
        place: zod_1.z.object({
            place: zod_1.z.string().describe('Lieu (champ BM)'),
        }),
    },
};
